import { Box } from "@chakra-ui/react";
import { Col, Row } from "antd";
import useGetCondominios from "features/tenants/hooks/useGetTenants";
import useFiltro from "infra/helpers/useFiltro";
import { useHistory } from "react-router-dom";
import useCondominioListagemColumns from "./components/useTenantListagemColumns";
import PageHeader from "components/Page/PageHeader";
import HeaderTable from "components/Page/HeaderTable";
import { useBreadcrumb } from "features/breadcrumbs";
import NewTable from "components/NewTable";
import Container from "components/Container";
import { TabMenuOptions } from "core/features/tenants/data/TabsMenuOptions";
import { TenantPaginateResponse } from "core/features/tenants/typings/tenant";
import { checkPermission } from "infra/helpers/permission";

function ListagemCondominios() {
  const history = useHistory();

  const { filtro, setFiltro, onChangeFiltro } = useFiltro();
  const { data, isLoading, isFetching, refetch } = useGetCondominios(filtro);

  const columns = useCondominioListagemColumns(refetch);

  useBreadcrumb([{ name: "Condomínios", url: "/condominio" }]);

  return (
    <Container>
      <PageHeader
        title="Condomínios"
        titleButton="Adicionar novo condomínio"
        onClick={() => history.push("/condominio/criar")}
      />

      <Row>
        <Col sm={24}>
          {/* <Row>
            <Col sm={18}>
              <DashboardCondominios />
            </Col>
            <Col sm={6}>
              <Sidebar img={condominioSvg} />
            </Col>
          </Row> */}

          <Box zIndex="1" pos="relative" mt="-10px">
            <NewTable<TenantPaginateResponse>
              title={() => (
                <HeaderTable
                  value={filtro.search as any}
                  onSearch={(q?: string) =>
                    setFiltro((prev: any) => ({
                      ...prev,
                      search: q,
                      page: 1,
                    }))
                  }
                />
              )}
              loading={isLoading || isFetching}
              columns={columns}
              dataSource={data?.items ?? []}
              actions={TabMenuOptions.filter((option) => {
                if (
                  option.permissions?.length &&
                  !checkPermission(option.permissions)
                ) {
                  return false;
                }

                return true;
              }).map((option) => ({
                title: option.label,
                onClick: (v) => {
                  history.push(`/condominio/${v.id}?opcao=${option.route}`);
                },
              }))}
              customPagination={{
                currentPage: data?.meta.currentPage ?? 0,
                itemsPerPage: data?.meta.itemsPerPage ?? 0,
                totalItems: data?.meta.totalItems ?? 0,
                onChangePage: (page: number) => {
                  onChangeFiltro("page", page);
                },
              }}
            />
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default ListagemCondominios;
